<template>
	<span>&nbsp;{{ text }}</span>
</template>

<script>
	export default {
		data: () => ({
			text: '',
			interval: false
		}),
		mounted() {
			var self = this;
			this.interval = setInterval(function() {
				let ln = self.text.length;
				if (ln < 3) {
					self.text += '.';
				} else {
					self.text = '';
				}
			}, 120);
		},
		beforeDestroy() {
			clearTimeout(this.interval);
		}
	}
</script>